export default __webpack_public_path__ + "img/fSwcJQtx.1b42b31e.svg";